import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Aug 27, 2026 — Theme boot. Reads user preference from localStorage
// (`agm.theme` = 'dark' | 'light'). Defaults to 'light' per admin policy.
// Applied before React mounts to prevent theme flash.
(function bootTheme() {
  try {
    const saved = localStorage.getItem('agm.theme');
    const theme = saved === 'dark' || saved === 'light' ? saved : 'light';
    const root = document.documentElement;
    root.classList.remove('dark', 'light');
    root.classList.add(theme);
  } catch (e) {
    document.documentElement.classList.add('light');
  }
})();

// Suppress webpack dev server error overlay for non-critical network errors
// These are caused by platform dev tools, not application bugs
const originalOnError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (message && (message.includes('Network Error') || message.includes('AxiosError'))) {
    return true; // Suppress the error
  }
  if (originalOnError) return originalOnError(message, source, lineno, colno, error);
  return false;
};

const originalOnUnhandledRejection = window.onunhandledrejection;
window.onunhandledrejection = function(event) {
  if (event.reason && (
    event.reason.message?.includes('Network Error') ||
    event.reason.name === 'AxiosError'
  )) {
    event.preventDefault();
    return;
  }
  if (originalOnUnhandledRejection) return originalOnUnhandledRejection(event);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
